import { render } from "./RanklistIndexView.vue?vue&type=template&id=59f644b4&scoped=true"
import script from "./RanklistIndexView.vue?vue&type=script&lang=js"
export * from "./RanklistIndexView.vue?vue&type=script&lang=js"

import "./RanklistIndexView.vue?vue&type=style&index=0&id=59f644b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f644b4"]])

export default __exports__